export default {
  CONFIRM_PASSWORD: 'Confirm password',
  FORGOT_PASSWORD_CAPTION: 'No worries. Enter your username and we will share a reset link on registered email address.',
  PASSWORD_EMAIL_SUCCESS: 'A new password has been sent to your registered email.',
  SENT_EMAIL_TITLE: 'New password sent',
  INVALID_RESET_PASS_LINK: 'Seems your reset password link is invalid, Please try again.',
  RESET_PASS_SUCCESS: 'Your password has been reset successfully, please logg-in.',
  RESET_PASS_LINK_EXPIRED: 'Seems your reset password link is expired, Please try again.',
  PASSWORDS_NOT_SAME: 'Password and confirm password should be same',
  RESET_PASSWORD: 'Reset password',
  RESET_PASSWORD_CAPTION: 'Please enter your new password and click submit button.'
}
